

































import { Component, Model, Prop, Vue } from 'vue-property-decorator';

import Typography from '@/componentsV2/atoms/Typography/Typography.vue';
import Checkbox from '@/components/Checkbox/Checkbox.vue';

@Component({
  components: {
    Typography,
    Checkbox
  }
})
export default class SwitchBox extends Vue {
  @Model('input') modelValue!: boolean;

  @Prop() title!: string;
  @Prop() description?: string;
  @Prop({ default: false }) disabled!: boolean;

  onInput(value: boolean) {
    this.$emit('input', value);
  }
}
